import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {


  constructor(private loaderService: LoaderService){
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.startLoading();
    return next.handle(req).pipe(
      finalize(()=>{
        this.stopLoading();
      })
    );
  }

  startLoading():void{
    this.loaderService.startLoading();
  }
  stopLoading():void{
    this.loaderService.stopLoading();
  }
}

export const loaderHttpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
];


// WEBPACK FOOTER //
// ./src/app/helper/core/loader/loader-interceptor.ts